export const copyToClipboard = async (text: string) => {
    if (navigator?.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        alert("This is copied to your clipboard:\n\n" + text)
    } else {
        const agent: string = window.navigator.userAgent
        const edge: number = agent.indexOf('Edge')

        const tempElement: HTMLTextAreaElement = document.createElement('textarea')
        tempElement.value = text
        tempElement.textContent = text
        document.body.appendChild(tempElement)

        const selection = document.getSelection()
        const range = document.createRange()

        range.selectNode(tempElement)
        selection?.removeAllRanges()
        selection?.addRange(range)
        if (edge > 0) tempElement.select() // for IE edge

        document.execCommand('copy')
        selection?.removeAllRanges()

        alert("This is copied to your clipboard:\n\n" + tempElement.value)
        document.body.removeChild(tempElement)
    }
}